import {
  ErrorEvent,
  SuccessEvent,
  useFinchConnect,
} from '@tryfinch/react-connect';
import { FINCH_ERRORS, getFinchConnectEnvParams } from '@zorro/common-utils';
import {
  showErrorNotification,
  useMonolithMutation,
} from '@zorro/web/ui-utils';

type Props = {
  employerId: string;
  successMessage?: string;
};

export const useFinchConnection = ({ employerId, successMessage }: Props) => {
  const { mutate: connect } = useMonolithMutation({
    method: 'finchControllerConnect',
  });

  const { mutate: connectCallback } = useMonolithMutation({
    successMessage,
    method: 'finchControllerConnectCallback',
  });

  const handleSuccess = async ({ code }: SuccessEvent) => {
    await connectCallback([{ employerId, code }]);
  };

  async function handleError(_event: ErrorEvent) {
    showErrorNotification({
      message: FINCH_ERRORS.CONNECT_PROCESS_FAILURE,
    });
  }

  const { open: openFinchConnect } = useFinchConnect({
    ...getFinchConnectEnvParams(),
    sessionId: undefined,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  async function handleConnect() {
    const { sessionId } = await connect([{ employerId }]);

    openFinchConnect({ sessionId });
  }

  return { handleConnect };
};
